module.exports = __webpack_public_path__ + "static/media/1val.7f20764b.png";